<template>
  <div>
    <h3>{{ $t('Filter by Station Details') }}</h3>

    <fieldset class="afdc-form-group">
      <div class="afdc-row">
        <legend class="afdc-col-form-label afdc-col-sm-4 afdc-pt-0">{{ $t('Access') }}</legend>
        <div class="afdc-col-sm-8">
          <div v-for="option in accessOptions" v-bind:key="option.key" class="afdc-custom-control afdc-custom-checkbox">
            <input type="checkbox" class="afdc-custom-control-input" v-bind:value="option.key" v-model="queryAccess" v-bind:id="'afdc-analyze-access-' + option.key">
            <label class="afdc-custom-control-label" v-bind:for="'afdc-analyze-access-' + option.key">{{ option.name }}</label>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="afdc-form-group">
      <div class="afdc-row">
        <legend class="afdc-col-form-label afdc-col-sm-4 afdc-pt-0">{{ $t('Status') }}</legend>
        <div class="afdc-col-sm-8">
          <div v-for="option in statusOptions" v-bind:key="option.key" class="afdc-custom-control afdc-custom-checkbox">
            <input type="checkbox" class="afdc-custom-control-input" v-bind:value="option.key" v-model="queryStatus" v-bind:id="'afdc-analyze-status-' + option.key">
            <label class="afdc-custom-control-label" v-bind:for="'afdc-analyze-status-' + option.key">{{ option.name }}</label>
            <span :content="statusDescription(option)" v-tippy="{ appendTo: 'parent', arrow : true, arrowType : 'round'}"><font-awesome-icon icon="info-circle" class="afdc-fa-icon"/></span>
          </div>
        </div>
      </div>
    </fieldset>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-vehicle-class">{{ $t('Vehicle Accessibility') }}</label>
      <div class="afdc-col-sm-8">
        <select v-model="queryMaximumVehicleClass" class="afdc-form-control afdc-custom-select" id="afdc-analyze-vehicle-class">
          <option v-for="option in vehicleClassOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-station-owner">{{ $t('Owner') }}</label>
      <div class="afdc-col-sm-8">
        <select v-model="queryOwner" class="afdc-form-control afdc-custom-select" id="afdc-analyze-station-owner">
          <option v-for="option in ownerTypeOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-station-payment">{{ $t('Payment') }}</label>
      <div class="afdc-col-sm-8">
        <select v-model="queryPayment" class="afdc-form-control afdc-custom-select" id="afdc-analyze-station-payment">
          <option v-for="option in paymentMethodOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import reject from 'lodash/reject';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {

  computed: {
    vehicleClassOptions() {
      return this.$store.getters.loaderVehicleClassOptions;
    },

    accessOptions() {
      return reject(this.$store.getters.loaderAccessTypes, { key: 'all' });
    },

    statusOptions() {
      return reject(this.$store.getters.loaderStatusTypes, { key: 'all' });
    },

    ownerTypeOptions() {
      return this.$store.getters.loaderOwnerTypes;
    },

    paymentMethodOptions() {
      return this.$store.getters.loaderPaymentMethods;
    },

    queryAccess: syncInputRouteQuery('access'),
    queryStatus: syncInputRouteQuery('status'),
    queryMaximumVehicleClass: syncInputRouteQuery('maximum_vehicle_class'),
    queryOwner: syncInputRouteQuery('owner'),
    queryPayment: syncInputRouteQuery('payment'),
  },

  methods: {
    statusDescription(option) {
      if (option.key === 'E') {
        return this.$t('Available Stations: The station is in service and available for drivers to use.');
      }

      if (option.key === 'P') {
        return this.$t('Planned Stations: The station is permitted or under construction.');
      }

      if (option.key === 'T') {
        return this.$t('Temporarily Unavailable Stations: The station is temporarily out of service or offline due to maintenance and plans to open again in the future.');
      }

      return undefined;
    },
  },
};

</script>

<style lang="scss">
</style>
